import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// eslint-disable-next-line import/no-unresolved
import { TemporaryDrawer } from 'components/drawer/navDrawer';
// import Menu from '@mui/material/Menu';

import Container from '@mui/material/Container';
// import Button from '@mui/material/Button';
import { useLocation } from 'react-router-dom';
// import DehazeIcon from '@mui/icons-material/Dehaze';

// import MenuItem from '@mui/material/MenuItem';
// eslint-disable-next-line import/no-unresolved
import { useDevice } from 'hooks/useResponsive';
import { Grid, InputAdornment, Link, Popover, Stack, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
// import SearchSharpIcon from '@mui/icons-material/SearchSharp';
// import { Menu } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { getAllVehicles } from '../../server/api/vehicle';
import Logo from '../../components/logo/Logo';

const pages = [
  // { item: 'Home', link: '/home' },
  { item: 'Buy Car', link: '/allproducts' },
  { item: 'Sell Your Car', link: '/sell' },
  { item: 'Dream Car', link: '/dream' },
];

function HeaderWeb() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isMobile } = useDevice();
  const inputRef = React.useRef(null);
  const [showHeader, setShowHeader] = React.useState(true);

  const [open, setOpen] = React.useState(false);

  const [search, setSearch] = React.useState('');
  const { allVehicleList } = useSelector((state) => ({
    allVehicleList: state.vehicle.allVehicleList?.vehicles,
  }));
  const [inputWidth, setInputWidth] = React.useState(300);

  React.useLayoutEffect(() => {
    if (inputRef.current) {
      setInputWidth(inputRef.current.offsetWidth);
    }
  }, [search]);

  React.useEffect(() => {
    const data = {
      search,
    };
    dispatch(getAllVehicles(data));
  }, [dispatch, search]);

  const handleSearch = (value) => {
    setSearch(value);

    if (value.trim().length > 0) {
      setOpen(true);
      dispatch(getAllVehicles({ search: value }));
    } else {
      setOpen(false);
    }
  };

  // React.useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (inputRef.current && !inputRef.current.contains(event.target)) {
  //       setOpen(false);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => document.removeEventListener('mousedown', handleClickOutside);
  // }, []);
  const popoverRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        popoverRef.current &&
        !popoverRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const lastScrollY = React.useRef(0);

  React.useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollY.current + 10) {
        setShowHeader(false);
      } else if (currentScroll < lastScrollY.current - 10) {
        setShowHeader(true);
      }
      lastScrollY.current = currentScroll;
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        position: 'fixed',
        left: 0,
        right: 0,
        zIndex: 1000,
        transform: showHeader ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'all ease-in-out 0.5s',
      }}
    >
      <AppBar
        position="static"
        sx={{
          backgroundColor: '#121212',
          // backgroundColor: 'rgba(18, 18, 18, 0.7)',
          backdropFilter: 'blur(26.3px)',

          WebkitBackdropFilter: 'blur(26.3px)',
          boxShadow: 'none',
          p: { xs: 0, sm: 2 },
          px: { xs: 0, sm: 7 },
          pb: { xs: 1 },
          pt: { xs: 2 },
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}
          >
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
              width={isMobile ? '100%' : 'fit-content'}
            >
              <Logo />
              {(location?.pathname === '/home' || location?.pathname === '/allproducts') && isMobile && (
                <Link href={'/search'} style={{ textDecoration: 'none' }}>
                  <Grid>
                    <TextField
                      size="small"
                      placeholder="Search Your fav Car"
                      type="text"
                      className="custom-field-Header"
                      sx={{
                        // height:'33px',
                        border: '0px solid gray',
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '16px',
                          '& fieldset': {
                            borderRadius: '16px',
                          },
                          '& input::placeholder': {
                            color: '#FFFFFF99',
                            opacity: 1,
                          },
                        },
                      }}
                      InputProps={{
                        autoComplete: 'off',
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" sx={{ color: '#FFA800', transform: 'rotate(90deg)' }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* <img
                src={`assets/images/Header/search.png`}
                alt=""
                style={{ position: 'absolute', top: 105, right: 30 }}
              /> */}
                  </Grid>
                </Link>
              )}
              {isMobile && <TemporaryDrawer />}
            </Box>

            {!isMobile && (
              <Box display={'flex'} flexDirection={'column'} sx={{ backgroundColor: '', width: '50%' }}>
                <>
                  <TextField
                    inputRef={inputRef}
                    size="small"
                    autoFocus
                    placeholder="Search Your fav Car"
                    type="text"
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="custom-field-Header"
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                        '& fieldset': {
                          border: 'none',
                        },
                        '&:hover fieldset': {
                          border: 'none',
                        },
                        '&.Mui-focused fieldset': {
                          border: 'none',
                        },
                        '& input::placeholder': {
                          color: '#FFFFFF99',
                          opacity: 1,
                        },
                        '& input': {
                          color: '#FFFFFFDE',
                        },
                      },
                    }}
                    InputProps={{
                      autoComplete: 'off',
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" sx={{ color: '#FFA800', transform: 'rotate(90deg)' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Popover
                    open={open && search.length > 0}
                    anchorEl={inputRef.current}
                    onClose={() => setOpen(false)}
                    disableAutoFocus // prevent stealing focus
                    disableEnforceFocus // prevent React from trying to "focus trap"
                    disableRestoreFocus
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{
                      ref: popoverRef,
                      sx: {
                        backgroundColor: '#1A1A1A',
                        color: 'white',
                        width: `${inputWidth}px`,
                        maxHeight: 300,
                        overflowY: 'auto',
                        borderRadius: 2,
                        mt: 1,
                        boxShadow: 'unset',
                        zIndex: 1201,
                        '&::-webkit-scrollbar': {
                          width: '4px',
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor: 'transparent',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#555',
                          borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-button': {
                          display: 'none', // ✅ hides those up/down arrows
                        },
                        scrollbarWidth: 'thin', // Firefox
                        scrollbarColor: '#555 transparent',
                      },
                    }}
                  >
                    {search?.length > 0 && allVehicleList?.length > 0 ? (
                      <Stack className="search-details">
                        {allVehicleList.map((item, key) => (
                          <Link
                            href={`/product-single/${item?._id}`}
                            key={key}
                            style={{ textDecoration: 'none', color: 'white' }}
                            onClick={() => setOpen(false)}
                          >
                            <Box display={'flex'} alignItems="center" p={1} width="100%">
                              <img
                                src={item?.images[0]?.url}
                                alt=""
                                height={25}
                                width={50}
                                style={{ objectFit: 'contain' }}
                              />
                              &nbsp;
                              <Typography>{item?.name}</Typography>
                            </Box>
                          </Link>
                        ))}
                      </Stack>
                    ) : (
                      <Typography className="search-details" sx={{ p: 1 }}>
                        No Vehicle
                      </Typography>
                    )}
                  </Popover>
                </>

                {/* )} */}
              </Box>
            )}

            <Box
              width={'100%'}
              sx={{
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'end',
                width: isMobile ? '100%' : 'fit-content',
              }}
            >
              {pages?.map((page, key) => (
                <Link
                  key={key}
                  // component={Link}
                  href={page?.link}
                  // onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: '#E3E3E3', display: 'flex', alignItems: 'center', mx: 3, textDecoration: 'none' }}
                >
                  <Typography
                    sx={{ padding: '3px 0px 0px 4px', color: '#FFFFFFDE', fontSize: '16px' }}
                    fontWeight={600}
                  >
                    {page?.item}
                  </Typography>
                </Link>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}

export default HeaderWeb;
HeaderWeb.propTypes = {};
